import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { ContratoRateio } from 'src/app/admihair/api/dto/contrato-rateio';
import { ContratoRateioService } from 'src/app/admihair/service/contrato-rateio.service';
import { ContratoService } from 'src/app/admihair/service/contrato.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-contrato-detalhar',
  templateUrl: './contrato-detalhar.component.html',
  styleUrls: ['./contrato-detalhar.component.scss']
})
export class ContratoDetalharComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  loadingContrato: boolean = false;
  contrato?: Contrato;
  listaRateios: ContratoRateio[] = [];

  constructor(private activatedRouter: ActivatedRoute,
    private contratoService: ContratoService,
    private contratoRateioService: ContratoRateioService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_CONTRATO');
    this.carregarIdCliente();
    if (this.permissaoDetalhar) {
      this.carregarContratoPorId();
    }
  }

  carregarContratoPorId() {
    this.loadingContrato = true
    this.contratoService.buscarContratoPorId(this.id).subscribe({
      next: (data: Contrato) => {
        this.contrato = data;
        this.carregarRateios();
      },
      error: (err: any) => {
        this.loadingContrato = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  carregarIdCliente() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }

  carregarRateios() {
    this.contratoRateioService.listarPorContrato(this.id).subscribe({
      next: (data: ContratoRateio[]) => {
        this.listaRateios = data;
        this.loadingContrato = false;
      },
      error: (err: any) => {
        this.loadingContrato = false;
        this.exibirMensagemErro(err);
      }
    })
  }

}
